import { AuthEmailPage } from '@/app/pages/auth/auth-email';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/')({
  component: AuthEmailPage,
});
